import { Message, Participant } from "@twilio/conversations";

export type AddMessagesType = (channelSid: string, messages: Message[]) => void;
export type SetSidType = (sid: string) => void;

export type SetParticipantsType = (
  participants: Participant[],
  sid: string
) => void;

export type SetUnreadMessagesType = (
  channelSid: string,
  unreadCount: number
) => void;

export enum ActionName {
  Save = "Salvar",
  Create = "Criar",
  Manage = "Gerenciar",
  Transfer = "Enviar",
}

export enum InputType {
  Text = "text",
  Password = "password",
}

export enum Content {
  AddChat = "Adicionar participante de chat",
  AddSMS = "Adicionar participante de SMS",
  AddWhatsApp = "Adicionar participante de WhatsApp",
}
